
<!------------------------- header start ------------------------------>
<header>


  <!-- navbar start -->
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand ml-5" routerLink="/home"><img src="/assets/Coverage/image/logo.svg" alt="Logo" /></a>
      <button class="navbar-toggler navbar-light" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mx-lg-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link active" aria-current="page"  routerLink="/coverage">Coverage</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/learningCenter">Learning Center</a>
          </li>
          <li class="nav-item">
            <a class="nav-link"  routerLink="/about">About </a>
          </li>
        </ul>
      </div>

      <ul class="navbar-nav last-navbar ml-lg-auto ml-0 mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link btn-orange" href="#">Get a quota</a>
        </li>
        <li class="nav-item user">
          <a class="nav-link" href="#"> <i class="far fa-user"></i> </a>
        </li>
      </ul>
    </div>
  </nav>





  <!-- hero area start -->
  <section class="hero-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 col-md-8 col-12 mx-auto">
          <h1>Expertly Built Coverage Options</h1>
          <h4>Honeycomb is the only resource you’ll ever need for real estate insurance </h4>
          <div class="hero-btn d-md-block d-none">
            <div class="row">
              <div class="col-6 clearfix">
                <a href="#" class="btn-black b-r float-right">Who We Insure</a>
              </div>
              <div class="col-6 clearfix">
                <a href="#" class="btn-black b-l float-left">Coverage</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- hero area end -->
</header>
<!------------------------- header end ------------------------------>
<!------------------------- cover start ------------------------------>
<section class="cover">
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <div class="cover-left">
          <h4 class="orange-text">Who It’s For</h4>
          <h1 class="section-header mt-3">We’ve Got You Covered</h1>
        </div>
      </div>
      <div class="col-md-8">
        <div class="cover-right">
          <p class="mt-5">Whether you represent a small HOA or you’re a bigwig developer or building owner, we believe in giving everyone the individualized attention they deserve. Honeycomb is real estate insurance on your terms, wherever and however you need it.</p>
        </div>
      </div>
    </div>


    <div class="cover-slider">
      <div class="row">
        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 my-4 d-flex">
          <div class="card">
            <img src="/assets/Coverage/image/coverage-card1.jpg" class="card-img-top" alt="card-photo">
            <div class="card-body">
              <h3 class="card-title">Homeowner Associations</h3>
              <p class="card-text">We keep HOA Boards and their tenants safe, at the most affordable price. </p>
              <a href="#" class="card-link">Get Your Quote <i class="fas fa-angle-right ml-2"></i></a>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 my-4 d-flex">
          <div class="card">
            <img src="/assets/Coverage/image/coverage-card2.jpg" class="card-img-top" alt="card-photo">
            <div class="card-body">

              <h3 class="card-title">Building Owners</h3>
              <br class="d-md-none d-lg-block">
              <p class="card-text">We help building owners find the most suitable coverage to preserve their investment.</p>
              <br >
              <a href="#" class="card-link">Get Your Quote <i class="fas fa-angle-right ml-2"></i></a>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 my-4 d-flex">
          <div class="card">
            <img src="/assets/Coverage/image/coverage-card3.jpg" class="card-img-top" alt="card-photo">
            <div class="card-body">
              <h3 class="card-title">Property Managers</h3>
              <p class="card-text">Access more quotes than they can obtain from an agent, in much less time, at very competitive prices. </p>
              <a href="#" class="card-link">Get Your Quote <i class="fas fa-angle-right ml-2"></i></a>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 my-4 d-flex">
          <div class="card">
            <img src="/assets/Coverage/image/coverage-card4.jpg" class="card-img-top" alt="card-photo">
            <div class="card-body">
              <h3 class="card-title">Developers</h3>
              <br class="d-md-none d-lg-block">
              <p class="card-text ">Reducing the cost of HOA insurance helps developers sell condos. </p>
              <br>
              <a href="#" class="card-link">Get Your Quote <i class="fas fa-angle-right ml-2"></i></a>
            </div>
          </div>
        </div>




      </div>
    </div>
  </div>
</section>
<!------------------------- cover end ------------------------------>
<!------------------------- control start ------------------------------>
<section class="control">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <h4 class="orange-text">Faster Coverage</h4>
        <h1 class="section-header mt-3">Take Control of Your Coverage Options</h1>
        <div class="control-body mt-5">
          <div class="row">
            <div class="col-md-6 mt-4">
              <h4 class="control-header"><img src="/assets/Coverage/image/coverage-font1.png" class="mr-2" alt=""> More Choice</h4>
              <p class="control-text">All base UI elements are made using Nested Symbols and shared styles that are logically connected with one another.</p>
            </div>

            <div class="col-md-6 mt-4">
              <h4 class="control-header"><img src="/assets/Coverage/image/coverage-font2.png" class="mr-2" alt="">Instant Customization </h4>
              <p class="control-text">All base UI elements are made using Nested Symbols and shared styles that are logically connected with one another.</p>
            </div>

            <div class="col-md-6 mt-4">
              <h4 class="control-header"><img src="/assets/Coverage/image/coverage-font3.png" class="mr-2" alt=""> Real-Time Quotes </h4>
              <p class="control-text">All base UI elements are made using Nested Symbols and shared styles that are logically connected with one another.</p>
            </div>
          </div>

        </div>
      </div>
      <div class="col-md-6 px-5">
        <div class="control-slider mt-5">
          <owl-carousel-o [options]="mySlide">
            <ng-template carouselSlide>
              <div class="item">
                <img src="/assets/Coverage/image/coverage-phone.png" alt="phone photo">
              </div>
            </ng-template>
            <ng-template carouselSlide>
              <div class="item">
                <img src="/assets/Coverage/image/coverage-phone.png" alt="phone photo">
              </div>
            </ng-template>
            <ng-template carouselSlide>
              <div class="item">
                <img src="/assets/Coverage/image/coverage-phone.png" alt="phone photo">
              </div>
            </ng-template>
          </owl-carousel-o>
          </div>
        </div>
    </div>
  </div>
</section>

<!------------------------- control end ------------------------------>
<!------------------------- offer start ------------------------------>
<section class="offer">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-8 col-sm-10 mx-auto text-center">
        <h4 class="orange-text">Broader Coverage</h4>
        <h1 class="section-header my-3">Honeycomb Offers More</h1>
        <p class="offer-header-text w-75 mx-auto d-md-block d-none">This is the part where we talk about all the bells and whistles that we can offer that others can’t or typically wont</p>
      </div>
    </div>
    <div class="offer-body">
      <div class="row">
        <div class="col-md-6 px-5">
          <h4 class="my-3">Enhanced Ordinace and Law Coverage</h4>
          <p class="pb-2">It covers the increased costs of reconstruction in the event that ordinance or law in the locality has changed requiring more expensive materials or additional elements which weren’t in the original building to be added upon reconstruction.</p>
        </div>

        <div class="col-md-6 px-5">
          <h4 class="my-3">Enhanced Electronic Data Coverage</h4>
          <p class="pb-2">It covers the increased costs of reconstruction in the event that ordinance or law in the locality has changed requiring more expensive materials or additional elements which weren’t in the original building to be added upon reconstruction.</p>
        </div>

        <div class="col-md-6 px-5">
          <h4 class="my-3">Service Lines Coverage</h4>
          <p class="pb-2">It covers the increased costs of reconstruction in the event that ordinance or law in the locality has changed requiring more expensive materials or additional elements which weren’t in the original building to be added upon reconstruction.</p>
        </div>

        <div class="col-md-6 px-5">
          <h4 class="my-3">Computer Fraud Protection</h4>
          <p class="pb-2">It covers the increased costs of reconstruction in the event that ordinance or law in the locality has changed requiring more expensive materials or additional elements which weren’t in the original building to be added upon reconstruction.</p>
        </div>
      </div>

    </div>
  </div>
</section>
<!------------------------- offer end ------------------------------>


<!-----------------------  start-hare start ----------------------->
<section class="start-hare">
  <div class="container">
    <h1 class="section-header text-center mb-5">Start Here</h1>
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-5">
        <div class="card">
          <div class="card-body px-lg-5 px-md-4">
            <img src="/assets/Coverage/image/coverage-man.png" alt="photo" class="img-fluid mt-3">
            <h2 class="card-title">HOA/Condo Association Master Policy</h2>
            <p class="card-text pb-4">We provide expert advice to HOA boards looking for the most suitable coverage options that would keep them and their tenants safe, at the most affordable price. Our insurance packages all include property, liability, D&O and Employee dishonesty coverage, as well as other optional coverage options. Our experts are available for you as a resource, to help build the best coverage package.</p>

            <a href="#" class="btn-orange d-block mx-auto ">Get a Quote</a>
          </div>
        </div>
      </div>

      <div class="col-md-5 mt-md-0 mt-5">
        <div class="card">
          <div class="card-body px-lg-5 px-md-4">
            <img src="/assets/Coverage/image/coverage-building.png" alt="photo" class="img-fluid mt-3">
            <h2 class="card-title">Apartment Building Master Policy</h2>
            <p class="card-text">The cost of property and casualty insurance comes straight out of a building owner’s bottom line profit and can impact the value of the property itself as insurance premiums are one of the most expensive operating costs for any given asset. Thus, finding the most suitable coverage to preserve the investment at the most cost effective price is both a protective measure and a potential profit enhancement opportunity for building owners.

            </p>

            <a href="#" class="btn-orange d-block mx-auto">Get a Quote</a>
          </div>
        </div>
      </div>
      <div class="col-md-1"></div>
    </div>
  </div>
</section>

<!-----------------------  start-hare end ----------------------->
<!-- coverage start -->
<section class="coverage">
  <div class="container">
    <div class="coverage-body">
      <div class="row">
        <div class="col-md-6">
          <h3>Better coverage is closer than you think</h3>
        </div>
        <div class="col-md-6 px-5 pt-4">
          <p class="coverage-text coverage-text1">Tell us about your property</p>
          <p class="coverage-text coverage-text2">Get an instant, personalized quote</p>
          <p class="coverage-text coverage-text3">Enjoy up to 50% savings</p>
        </div>
        <div class="col-md-6">
          <p class="text-center mt-md-0 mt-5"><a href="#" class="btn-orange d-block w-50 mx-auto">Get Start</a></p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-----------------------  social start ----------------------->
<div class="social py-5">
  <div class="container-fluid">
    <img src="/assets/image/Vector.svg" class="d-lg-block d-none mx-auto" alt="Logo" />
    <img src="/assets/Coverage/image/logo.svg" class="d-lg-none d-block mx-auto" alt="Logo">
  </div>
  <p class="social-links text-center d-lg-none d-block mt-4">
    <a href="#"><i class="fab fa-facebook-square"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-linkedin"></i></a>
  </p>
  <nav>
    <div class="container-fluid my-5">
      <p class="text-center">
        <a routerLink="/coverage">Coverage</a>
        <a routerLink="/learningCenter">Learning Center</a>
        <a routerLink="expertAsk">Ask The Expert</a>
        <a routerLink="/about">About</a>
      </p>
    </div>
  </nav>

  <p class="social-links text-center d-lg-block d-none">
    <a href="#"><i class="fab fa-facebook-square"></i></a>
    <a href="#"><i class="fab fa-twitter"></i></a>
    <a href="#"><i class="fab fa-linkedin"></i></a>
  </p>
</div>
<!-----------------------  social end ----------------------->
<!------------------------- footer start ------------------------------>
<footer>
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <p class="text-lg-left d-lg-block d-none text-center"> &#169; 2020 Honeycomb Insurance. All rights reserved.</p>
        <p class="text-lg-left d-lg-none d-block text-center"> &#169; © 2020 Acme. All right reserved.</p>
      </div>
      <div class="col-lg-6">
        <p class="text-lg-right text-center">
          <a href="#" class="d-lg-inline d-block">Privacy Policy</a>
          <a href="#" class="d-lg-inline d-block my-4">Terms of Service</a>
        </p>
      </div>
    </div>
  </div>
</footer>
<!------------------------- footer end ------------------------------>


